import React from "react";
import { Navigate, useParams } from "react-router-dom";

import { useUserStore } from "@store/userStore";

interface IOrganizationRouteMiddlewareProperties {
  children: React.ReactNode;
  redirectTo: string;
}

function OrganizationRouteMiddleware({ children, redirectTo }: IOrganizationRouteMiddlewareProperties) {
  const { organizationId } = useParams();
  const userOrganizationId = useUserStore((state) => state.organizationId);
  const isAuthorized = userOrganizationId && userOrganizationId === organizationId;

  return isAuthorized ? children : <Navigate to={redirectTo} />;
}

export default OrganizationRouteMiddleware;
